import { RECOMMENDATION } from "../actionTypes";
import { deepClone, getApiExchangeNameFromMktSegId } from "../../utils/global_functions";
import { _recommendation } from "../../controllers";
import { getScripInfo } from "./scripInfo";
import { _getWhatsHotData } from "../../controllers/watchlist";
import { getWhatsHotDataSuccess } from "./dontMiss";


export const recommendation = (allowedNewsCat, pageNo, pageSize) => async (dispatch, getState) => {

    const whatsHotData = deepClone(getState().dontMiss?.whatsHotData);
    const holdingsScrips = deepClone(getState().holdings?.holdingsScrips);
    //Prachi T :BT-107377 - 15-11-2023 ScripInnfo recommendations - Start
    let arrWhatsHotData = [];
    if (whatsHotData?.length > 0) {
        arrWhatsHotData = whatsHotData;
    } else {
        const arrWhatsHotDataFromApi = await _getWhatsHotData();
        arrWhatsHotData = arrWhatsHotDataFromApi?.data?.data?.result?.length > 0 ? arrWhatsHotDataFromApi?.data?.data?.result : [];
        dispatch(getWhatsHotDataSuccess(arrWhatsHotData));
    }

    const objresponse = await _recommendation(allowedNewsCat, pageNo, pageSize, arrWhatsHotData, holdingsScrips);
    //Prachi T :BT-107377 - 15-11-2023 ScripInnfo recommendations - End
    // Hari K : 09-08-2023 get the scrip information of recommendations-start
    // const arrUniqueScrips = [];
    // const seenCombination = {};
    // objresponse?.data?.recommendations?.forEach(element => {
    //     const segmentAndToken = `${element.nMarketSegmentId}-${element.nToken}`;
    //     if (!seenCombination[segmentAndToken]) {
    //         seenCombination[segmentAndToken] = true;
    //         arrUniqueScrips.push({ "mkt": getApiExchangeNameFromMktSegId(element?.nSegmentId), "token": element.nToken });
    //     }
    // });
    // dispatch(getScripInfo(arrUniqueScrips));

    // Hari K : 09-08-2023 get the scrip information of recommendations-end

    if (objresponse.status && objresponse?.data?.recommendations?.length > 0) {
        dispatch(recommendationSuccess(objresponse.data.recommendations));
        dispatch(recommendationTagsSuccess(objresponse.data)); //Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
        return Promise.resolve(objresponse.data.recommendations);

    } else {
        dispatch(recommendationFailure([]));
        return [];
    }

};

export const recommendationTags = (arrBrokerTags) => async (dispatch, getState) => {
    dispatch(recommendationBrokerTagsSuccess(arrBrokerTags));
};

export const recommendationBrokerTagsSuccess = (payload) => {
    return { type: RECOMMENDATION.GET_RECOMMENDATIONS_BROKER_TAGS, payload };
};

export const recommendationTagsSuccess = (payload) => {
    return { type: RECOMMENDATION.GET_RECOMMENDATIONS_TAGS, payload };
};

export const recommendationSuccess = (payload) => {
    return { type: RECOMMENDATION.GET_RECOMMENDATIONS_SUCCESS, payload };
};

export const recommendationFailure = (payload) => {
    return { type: RECOMMENDATION.GET_RECOMMENDATIONS_FAILURE, payload };
};

export const topTenRecommendation = (payload) => {
    return { type: RECOMMENDATION.TOP_TEN_RECOMMENDATIONS, payload };
};



